/* ============================================================
   Ant Design 5 — theme override for Signal Console.
   Drives all Ant components via <ConfigProvider theme={...}>.
   ============================================================ */

import type { ThemeConfig } from 'antd';

export const signalTheme: ThemeConfig = {
  token: {
    colorPrimary:       '#0891B2',
    colorPrimaryHover:  '#0E7490',
    colorPrimaryActive: '#155E75',
    colorInfo:          '#0891B2',
    colorSuccess:       '#15803D',
    colorWarning:       '#B45309',
    colorError:         '#B91C1C',

    colorBgLayout:      '#F4F6F9',
    colorBgContainer:   '#FFFFFF',
    colorBgElevated:    '#FFFFFF',
    colorBorder:        '#DCE1E9',
    colorBorderSecondary:'#E2E6EE',

    colorText:          '#1B2233',
    colorTextSecondary: '#5B6577',
    colorTextTertiary:  '#8892A6',
    colorTextQuaternary:'#AAB2C2',

    borderRadius:        5,
    borderRadiusSM:      3,
    borderRadiusLG:      8,

    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize:       14,
    fontSizeSM:     12,
    lineHeight:     1.55,

    controlOutline: 'rgba(8, 145, 178, 0.15)',
    boxShadow:      '0 1px 2px rgba(27,34,51,0.05), 0 1px 3px rgba(27,34,51,0.06)',
  },
  components: {
    Layout: {
      siderBg:  '#1B2233',
      headerBg: '#FFFFFF',
    },
    Menu: {
      darkItemBg:        '#1B2233',
      darkSubMenuItemBg: '#141A26',
      darkItemSelectedBg:'#0891B2',
      darkItemHoverBg:   'rgba(255,255,255,0.06)',
    },
    Table: {
      headerBg:        '#F4F6F9',
      headerColor:     '#5B6577',
      borderColor:     '#E2E6EE',
      rowHoverBg:      '#F0F4F8',
      cellPaddingBlock: 10,
    },
    Button: {
      primaryShadow:   'none',
      defaultBorderColor:'#C6CDD9',
    },
    Input: {
      activeBorderColor: '#0891B2',
      hoverBorderColor:  '#0E7490',
      activeShadow:      '0 0 0 2px rgba(8,145,178,0.12)',
    },
    Tag: {
      borderRadiusSM: 3,
    },
    Drawer: {
      colorBgElevated: '#FFFFFF',
    },
    Modal: {
      colorBgElevated: '#FFFFFF',
    },
    Select: {
      optionSelectedBg: '#F0F4F8',
    },
  },
};
